import { DI, IEventAggregator } from "aurelia";

export const IGoogleAnalytics = DI.createInterface<IGoogleAnalytics>(
  "IGoogleAnalytics",
  (x) => x.singleton(GoogleAnalytics)
);
export interface IGoogleAnalytics extends GoogleAnalytics {}

export class GoogleAnalytics {
  constructor(@IEventAggregator readonly ea: IEventAggregator) {}

  init(trackingCode) {
    const script = document.createElement("script");
    script.text =
      '(function(i,s,o,g,r,a,m){i["GoogleAnalyticsObject"]=r;i[r]=i[r]||function(){' +
      "(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o)," +
      "m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)" +
      '})(window,document,"script","https://www.google-analytics.com/analytics.js","ga");';
    document.querySelector("body").appendChild(script);

    (window as any).ga =
    (window as any).ga ||
      function () {
        // eslint-disable-next-line prefer-rest-params
        ((window as any).ga.q = (window as any).ga.q || []).push(arguments);
      };

      (window as any).ga.l = +new Date();

    (window as any).ga(() => {
      const trackers = (window as any).ga.getAll();
      if (!trackers.length) {
        this.create(trackingCode, "auto");
      }
    });
  }

  attach() {
    this.attachPageTracker();
    this.attachExceptionTracker();
  }

  /**
   * Execute
   *
   * Method calls the Google Analytics Window method
   * and tells it was we are doing.
   *
   * @param command
   * @param args
   * @return void
   */
  execute(command, args) {
    args.unshift(command);
    (window as any).ga.apply((window as any).ga, args);
  }

  /**
   * Create
   *
   * Used for creating events.
   *
   * @param args
   * @return void
   */
  create(...args) {
    this.execute("create", args);
  }

  /**
   * Send
   *
   * Sends a Google Analytics event. Supports multiple arguments in the form of
   * the spread operator obtaining them.
   *
   * @example
   * this.ga.send('pageview', '/');
   *
   * @param args
   * @return void
   */
  send(...args) {
    this.execute("send", args);
  }

  /**
   * Set
   *
   * Sends a Google Analytics set call.
   *
   * @param {*} args
   * @return void
   */
  set(...args) {
    this.execute("set", args);
  }

  /**
   * Attach Page Tracker
   *
   * Listens for successful router changes and fires off an event to Google Analytics
   * to track page changes
   *
   * @return void
   */
  attachPageTracker() {
    this.ea.subscribe("router:navigation:success", (payload: any) => {
      this.set(
        "page",
        payload.instruction.fragment,
        payload.instruction.title || document.title
      );
      this.send("pageview");
    });
  }

  attachExceptionTracker() {
    const windowOnerror = window.onerror;

    window.onerror = (
      errorMessage,
      url,
      lineNumber,
      columnNumber,
      errorObject
    ) => {
      if (typeof (window as any).ga === "function") {
        let exceptionDescription;

        if (
          errorObject !== undefined &&
          typeof errorObject.message !== undefined
        ) {
          exceptionDescription = errorObject.message;
        } else {
          exceptionDescription = errorMessage;
        }

        exceptionDescription += " @ " + url;

        if (lineNumber !== undefined && columnNumber !== undefined) {
          exceptionDescription += ":" + lineNumber + ":" + columnNumber;
        }

        this.send("exception", {
          exDescription: exceptionDescription,
          exFatal: false,
        });
      }

      if (typeof windowOnerror === "function") {
        return windowOnerror(
          errorMessage,
          url,
          lineNumber,
          columnNumber,
          errorObject
        );
      }

      return false;
    };
  }
}
